import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { PublisherCollectingSocietyCreateStore } from "../../store";
import { InputReference } from "../../../common/controls";
import { CreateEntityDialog } from "../../../common/controls";
import { CollectiveManagementSocietyCreate } from "../../../collectiveManagementSociety/components/create/CollectiveManagementSocietyCreate";
import { CollectiveManagementSocietyCreateStore } from "../../../collectiveManagementSociety/store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type PublisherCollectingSocietyCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  collectingSocietySelectedValue?: { displayId: string; id: string } | null;
  onCollectingSocietySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  onCollectingSocietyChange?: (value: string) => void;
  collectingSocietyOptions?: { displayId: string; id: string }[];
  collectingSocietyError?: string;
  cmsAccountNumberSelectedValue?: { displayId: string; id: string } | null;
  onCmsAccountNumberChange?: (value: string) => void;
  cmsAccountNumber: string;
  cmsAccountNumberError?: string;
  publisherCollectingSocietyCreateStore: PublisherCollectingSocietyCreateStore;
};

export const PublisherCollectingSocietyCreateForm: React.FC<PublisherCollectingSocietyCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      onCollectingSocietySelected = () => {},
      collectingSocietySelectedValue = null,
      collectingSocietyOptions = [],
      collectingSocietyError,
      onCollectingSocietyChange = () => {},
      cmsAccountNumber = "",
      cmsAccountNumberError,
      onCmsAccountNumberChange = () => {},
      publisherCollectingSocietyCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="PublisherCollectingSociety"
              mode="create"
              values={{}}
              options={{ collectingSociety: collectingSocietyOptions }}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "collectingSociety":
                    onCollectingSocietySelected?.(valor);
                    break;
                  case "cmsAccountNumber":
                    onCmsAccountNumberChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={publisherCollectingSocietyCreateStore.getCardErrors(
                "null"
              )}
              title={langStore.groupPublisherCollectingSocietyLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputReference
                  id="collectingSociety"
                  label={
                    langStore.PublisherCollectingSocietyCollectingSocietyLabel
                  }
                  autoFocus
                  error={Boolean(collectingSocietyError)}
                  helperText={
                    collectingSocietyError ||
                    publisherCollectingSocietyCreateStore.warnings[
                      "collectingSociety"
                    ]?.message
                  }
                  selectedValue={collectingSocietySelectedValue}
                  onChange={(value: string) => onCollectingSocietyChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onCollectingSocietySelected(value)
                  }
                  options={collectingSocietyOptions}
                  description={
                    langStore.PublisherCollectingSocietyCollectingSocietyDescription
                  }
                  canCreate={rootStore.authStore.hasPermissions(
                    "collectiveManagementSociety_create"
                  )}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new CollectiveManagementSocietyCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <CollectiveManagementSocietyCreate
                          collectiveManagementSocietyCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewCollectiveManagementSociety"
                      cancelMethod="cancelNewCollectiveManagementSociety"
                    />
                  )}
                />

                <InputString
                  value={cmsAccountNumber}
                  error={Boolean(cmsAccountNumberError)}
                  warning={
                    !cmsAccountNumberError &&
                    Boolean(
                      publisherCollectingSocietyCreateStore.warnings[
                        "cmsAccountNumber"
                      ]
                    )
                  }
                  helperText={
                    cmsAccountNumberError ||
                    publisherCollectingSocietyCreateStore.warnings[
                      "cmsAccountNumber"
                    ]?.message
                  }
                  label={
                    langStore.PublisherCollectingSocietyCmsAccountNumberLabel
                  }
                  onChange={(value: string) => onCmsAccountNumberChange(value)}
                  description={
                    langStore.PublisherCollectingSocietyCmsAccountNumberDescription
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
